import { Component, input } from '@angular/core';
import { SafePipe } from '@shared/pipe.safe';

@Component({
  selector: 'app-tnc-basic',
  standalone: true,
  imports: [SafePipe],
  templateUrl: './tnc-basic.component.html',
  styleUrl: './tnc-basic.component.scss'
})
export class TncBasicComponent {
  termsContent = input<string>();
}
